import { Truck, ShieldCheck, Sparkles, BadgePercent } from "lucide-react";
import { useLang } from "../context/LanguageContext";

/**
 * Static informational strip (replaces the scrolling marquee).
 * Four pill items showing the key facts every customer needs to see.
 */
export const Marquee = () => {
    const { lang } = useLang();
    const t = (en, te) => (lang === "en" ? en : te);

    const items = [
        {
            icon: Truck,
            title: t("Free delivery on 1 kg+ in AP & Telangana", "ఏపీ, తెలంగాణలో 1 కేజీ+ ఆర్డర్లకు ఉచిత డెలివరీ"),
            sub: t("Pan-India · 3–5 days", "భారతదేశ వ్యాప్తంగా · 3–5 రోజులు"),
        },
        {
            icon: ShieldCheck,
            title: t("FSSAI Licensed Kitchen", "FSSAI అనుమతి పొందిన వంటగది"),
            sub: t("No preservatives · No colours", "కృత్రిమ పదార్థాలు లేవు"),
        },
        {
            icon: Sparkles,
            title: t("Hand-Poured by Kumari Amma", "కుమారి Amma చేతి రుచి"),
            sub: t("Family recipes since 2000", "2000 నుండి తరతరాల రుచులు"),
        },
        {
            icon: BadgePercent,
            title: t("Launch Offer · Up to 20% off", "లాంచ్ ఆఫర్ · 20% వరకు తగ్గింపు"),
            sub: t(
                "Introductory prices on every pack — while the first batches last.",
                "ప్రతి ప్యాకెట్‌పై పరిచయ ధరలు — మొదటి బ్యాచ్‌లు ఉన్నంత వరకు.",
            ),
        },
    ];

    return (
        <section
            className="border-y-2 border-[color:var(--kp-turmeric)] bg-[color:var(--kp-terracotta)] text-[color:var(--kp-cream)]"
            data-testid="info-bar"
        >
            <div className="max-w-[1300px] mx-auto px-5 md:px-10 py-5 md:py-6">
                <ul className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
                    {items.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <li
                                key={i}
                                className="flex items-start gap-3 border-l-2 border-[color:var(--kp-turmeric)]/40 pl-3 md:pl-4"
                                data-testid={`info-item-${i}`}
                            >
                                <Icon size={20} className="shrink-0 text-[color:var(--kp-turmeric)] mt-0.5" />
                                <div className="min-w-0">
                                    <div className="text-[12px] md:text-[13px] font-bold leading-tight">
                                        {it.title}
                                    </div>
                                    <div className="text-[10px] md:text-[11px] opacity-80 mt-0.5 leading-snug">
                                        {it.sub}
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
};
